// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-HR-TimeRecap-___TableTimeRecap-module__cellDay {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: 'Noto Sans';
  position: relative;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

  .app-pages-HR-TimeRecap-___TableTimeRecap-module__cellDay .app-pages-HR-TimeRecap-___TableTimeRecap-module__quickView {
    display: none;
    pointer-events: none;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .app-pages-HR-TimeRecap-___TableTimeRecap-module__cellDay .app-pages-HR-TimeRecap-___TableTimeRecap-module__quickView .app-pages-HR-TimeRecap-___TableTimeRecap-module__tooltip {
      height: -moz-fit-content;
      height: fit-content;
      background-color: rgba(60, 60, 60, 0.8);
      padding: 6px;
      color: #ffffff;
      border-radius: 4px;
      font-size: 72%;
      margin: 6px 0px;
      pointer-events: none;
      position: absolute;
      z-index: 10;
    }

  .app-pages-HR-TimeRecap-___TableTimeRecap-module__cellDay .app-pages-HR-TimeRecap-___TableTimeRecap-module__quickView .app-pages-HR-TimeRecap-___TableTimeRecap-module__tooltipLeft {
      right: 0%;
    }

  .app-pages-HR-TimeRecap-___TableTimeRecap-module__cellDay .app-pages-HR-TimeRecap-___TableTimeRecap-module__quickView .app-pages-HR-TimeRecap-___TableTimeRecap-module__tooltipBottom {
      top: 100%;
    }

  .app-pages-HR-TimeRecap-___TableTimeRecap-module__cellDay .app-pages-HR-TimeRecap-___TableTimeRecap-module__quickView .app-pages-HR-TimeRecap-___TableTimeRecap-module__tooltipRight {
      left: 100%;
    }

  .app-pages-HR-TimeRecap-___TableTimeRecap-module__cellDay .app-pages-HR-TimeRecap-___TableTimeRecap-module__quickView .app-pages-HR-TimeRecap-___TableTimeRecap-module__tooltipTop {
      bottom: 100%;
      top: unset;
    }

  .app-pages-HR-TimeRecap-___TableTimeRecap-module__cellDay:hover .app-pages-HR-TimeRecap-___TableTimeRecap-module__quickView {
    display: block;
  }

.app-pages-HR-TimeRecap-___TableTimeRecap-module__isTotal {
  opacity: 0.3;
  font-weight: normal;
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__morningOff {
  z-index: -1000;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50%;
  position: absolute;
  top: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.11);
  background: repeating-linear-gradient(120deg, white, white 6px, rgba(0, 0, 0, 0.11) 6px, rgba(0, 0, 0, 0.11) 12px);
  background-repeat: no-repeat;
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__afternoonOff {
  z-index: -1000;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.11);
  background: repeating-linear-gradient(120deg, white, white 6px, rgba(0, 0, 0, 0.11) 6px, rgba(0, 0, 0, 0.11) 12px);
  background-repeat: no-repeat;
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__fullDayOff {
  z-index: -1000;
  display: flex;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(120deg, white, white 6px, rgba(0, 0, 0, 0.11) 6px, rgba(0, 0, 0, 0.11) 12px);
  background-repeat: no-repeat;
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__warning.app-pages-HR-TimeRecap-___TableTimeRecap-module__isTotal {
  opacity: 0.8;
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__isWeekend {
  box-shadow: 0 0 0 50px rgba(0, 0, 0, 0.05) inset;
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__warning {
  color: var(--colors-orange);
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__tr:hover {
  box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.05);
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__footer {
  background-color: #ffffff;
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__haveAnActivityApprovalsComment {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 1;
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__hourglassIcon {
  position: absolute;
  top: 2px;
  left: 2px;
  font-size: 11px;
}

.app-pages-HR-TimeRecap-___TableTimeRecap-module__leaveApproved {
  background-color: rgb(84, 170, 255);
}
`, "",{"version":3,"sources":["webpack://./app/pages/HR/TimeRecap/TableTimeRecap.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AAuCnB;;EArCE;IACE,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,YAAY;EA2Bd;;EAzBE;MACE,wBAAmB;MAAnB,mBAAmB;MACnB,uCAAuC;MACvC,YAAY;MACZ,cAAc;MACd,kBAAkB;MAClB,cAAc;MACd,eAAe;MACf,oBAAoB;MACpB,kBAAkB;MAClB,WAAW;IACb;;EACA;MACE,SAAS;IACX;;EACA;MACE,SAAS;IACX;;EACA;MACE,UAAU;IACZ;;EACA;MACE,YAAY;MACZ,UAAU;IACZ;;EAGF;IACE,cAAc;EAChB;;AAGF;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,4CAA4C;EAC5C,kHAAkH;EAClH,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,yCAAyC;EACzC,kHAAkH;EAClH,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kHAAkH;EAClH,4BAA4B;AAC9B;;AAQA;EACE,YAAY;AACd;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".cellDay {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-family: 'Noto Sans';\n  position: relative;\n  user-select: none;\n\n  .quickView {\n    display: none;\n    pointer-events: none;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n\n    .tooltip {\n      height: fit-content;\n      background-color: rgba(60, 60, 60, 0.8);\n      padding: 6px;\n      color: #ffffff;\n      border-radius: 4px;\n      font-size: 72%;\n      margin: 6px 0px;\n      pointer-events: none;\n      position: absolute;\n      z-index: 10;\n    }\n    .tooltipLeft {\n      right: 0%;\n    }\n    .tooltipBottom {\n      top: 100%;\n    }\n    .tooltipRight {\n      left: 100%;\n    }\n    .tooltipTop {\n      bottom: 100%;\n      top: unset;\n    }\n  }\n\n  &:hover .quickView {\n    display: block;\n  }\n}\n\n.isTotal {\n  opacity: 0.3;\n  font-weight: normal;\n}\n\n.morningOff {\n  z-index: -1000;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 50%;\n  position: absolute;\n  top: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.11);\n  background: repeating-linear-gradient(120deg, white, white 6px, rgba(0, 0, 0, 0.11) 6px, rgba(0, 0, 0, 0.11) 12px);\n  background-repeat: no-repeat;\n}\n\n.afternoonOff {\n  z-index: -1000;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 50%;\n  position: absolute;\n  bottom: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.11);\n  background: repeating-linear-gradient(120deg, white, white 6px, rgba(0, 0, 0, 0.11) 6px, rgba(0, 0, 0, 0.11) 12px);\n  background-repeat: no-repeat;\n}\n\n.fullDayOff {\n  z-index: -1000;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: repeating-linear-gradient(120deg, white, white 6px, rgba(0, 0, 0, 0.11) 6px, rgba(0, 0, 0, 0.11) 12px);\n  background-repeat: no-repeat;\n}\n\n// .isLeaveOnCell {\n//   background-color: rgba(255, 255, 255);\n//   padding: 2px 3px;\n//   border-radius: 10px;\n// }\n\n.warning.isTotal {\n  opacity: 0.8;\n}\n\n.isWeekend {\n  box-shadow: 0 0 0 50px rgba(0, 0, 0, 0.05) inset;\n}\n\n.warning {\n  color: var(--colors-orange);\n}\n\n.tr:hover {\n  box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.05);\n}\n\n.footer {\n  background-color: #ffffff;\n}\n\n.haveAnActivityApprovalsComment {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.1);\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  z-index: 1;\n}\n\n.hourglassIcon {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  font-size: 11px;\n}\n\n.leaveApproved {\n  background-color: rgb(84, 170, 255);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cellDay": `app-pages-HR-TimeRecap-___TableTimeRecap-module__cellDay`,
	"quickView": `app-pages-HR-TimeRecap-___TableTimeRecap-module__quickView`,
	"tooltip": `app-pages-HR-TimeRecap-___TableTimeRecap-module__tooltip`,
	"tooltipLeft": `app-pages-HR-TimeRecap-___TableTimeRecap-module__tooltipLeft`,
	"tooltipBottom": `app-pages-HR-TimeRecap-___TableTimeRecap-module__tooltipBottom`,
	"tooltipRight": `app-pages-HR-TimeRecap-___TableTimeRecap-module__tooltipRight`,
	"tooltipTop": `app-pages-HR-TimeRecap-___TableTimeRecap-module__tooltipTop`,
	"isTotal": `app-pages-HR-TimeRecap-___TableTimeRecap-module__isTotal`,
	"morningOff": `app-pages-HR-TimeRecap-___TableTimeRecap-module__morningOff`,
	"afternoonOff": `app-pages-HR-TimeRecap-___TableTimeRecap-module__afternoonOff`,
	"fullDayOff": `app-pages-HR-TimeRecap-___TableTimeRecap-module__fullDayOff`,
	"warning": `app-pages-HR-TimeRecap-___TableTimeRecap-module__warning`,
	"isWeekend": `app-pages-HR-TimeRecap-___TableTimeRecap-module__isWeekend`,
	"tr": `app-pages-HR-TimeRecap-___TableTimeRecap-module__tr`,
	"footer": `app-pages-HR-TimeRecap-___TableTimeRecap-module__footer`,
	"haveAnActivityApprovalsComment": `app-pages-HR-TimeRecap-___TableTimeRecap-module__haveAnActivityApprovalsComment`,
	"hourglassIcon": `app-pages-HR-TimeRecap-___TableTimeRecap-module__hourglassIcon`,
	"leaveApproved": `app-pages-HR-TimeRecap-___TableTimeRecap-module__leaveApproved`
};
export default ___CSS_LOADER_EXPORT___;
